import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { LineModel, PartModel } from 'franke-trough-dependencies';
import PartListItem from './PartListItem';
import { find as _find } from 'lodash';

export interface PartListPartialProps {
  checkout: GlobalPrivateState['checkout'];
}

export class PartListPartial extends React.Component<PartListPartialProps> {
  public render() {
    return this.checkoutParts && this.checkoutParts.length > 0 && this.checkout ? (
      <div className="selected-products part-list">
        <ul>
          {this.checkoutParts.map((item, index) => {
            const part = item.part as PartModel;

            return (
              <li key={part.id || index}>
                <PartListItem lineItem={item} part={part} /> 
              </li>
            );
          })}
        </ul>
      </div>
    ) : null;
  }

  get checkout(): GlobalPrivateState['checkout']['result'] | undefined {
    return this.props.checkout.result;
  }

  get checkoutParts(): LineModel[] | undefined {
    return this.checkout && this.checkout.lines.parts;
  }
}

export const PartList = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
}))(PartListPartial);

export default PartList;
